export function liveReload(langDictionary, socketClient) {

    socketClient.on("lang:change", (event) => {
        onChangeLang(event.file, event.content);
    });

    function onChangeLang(file, content) {
        // file: "/ru/field_name/LIST_COMPANY.js"
        // content: "...source code..."

        const fileLang = file.slice(1, 3); // "ru" or "en"
        if ( window.lang !== fileLang ) {
            return;
        }

        // "/ru/field_name/LIST_COMPANY.js"  => ["field_name", "LIST_COMPANY.js"]
        // "/ru/texts.js"  => ["texts.js"]
        const path = file.split("/").slice(2);
        // object with new translates
        const changes = extractObject(content);
        if ( !changes ) {
            return;
        }

        if ( path[0] === "field_name" || path[0] === "fields" ) {
            const fileName = path[1];
            onChangeFieldName(fileName, changes);
        }
        else if ( path[0] === "forms" ) {
            const fileName = path[1];
            onChangeForms(fileName, changes);
        }
        else if ( path[0] === "texts.js" ) {
            onChangeTexts(changes);
        }
        else {
            const fileName = path[0];
            onChangeOther(fileName, changes);
        }
    }

    function onChangeFieldName(fileName, newFields) {
        const entityName = fileName.replace(".js", "");

        const fields = langDictionary.FIELD_NAME[ entityName ] || {};
        langDictionary.FIELD_NAME[ entityName ] = fields;

        applyNewTranslates(fields, newFields);

        triggerFieldsChange(entityName);
    }

    function triggerFieldsChange(entityName) {
        system.trigger("lang:fields:change", {
            entity: entityName
        });

        const tree = langDictionary.trees.FIELD_NAME;
        const treeNode = tree && tree.all[ entityName ];
        if ( !treeNode ) {
            return;
        }

        treeNode.children.getAll().forEach((childNode) => {
            const childEntityName = childNode.id;

            system.trigger("lang:fields:change", {
                entity: childEntityName
            });
        });
    }

    function onChangeForms(fileName, changes) {
        const formName = fileName.replace(".js", "");

        const fields = langDictionary.FORMS[ formName ] || {};
        langDictionary.FORMS[ formName ] = fields;

        applyNewTranslates(fields, changes);

        system.trigger("lang:form:change", {
            form: formName
        });
    }

    function onChangeTexts(newTexts) {
        applyNewTranslates(langDictionary._data, newTexts);
        system.trigger("lang:texts:change");
    }

    function onChangeOther(fileName, changes) {
        const dictionaryName = fileName.replace(".js", "").toUpperCase();
        const dictionary = langDictionary[ dictionaryName ];

        if ( !dictionary ) {
            console.log("[live reload langDictionary] unknown file: " + fileName);
            return;
        }

        applyNewTranslates(dictionary, changes);
        system.trigger("lang:other:change", {
            dictionaryName
        });
    }
}

function extractObject(fileContent) {

    const objectCode = fileContent.slice(
        fileContent.indexOf("{"),
        fileContent.lastIndexOf("}") + 1
    );

    let resultObject = {};
    try {
        resultObject = (new Function("", "return " + objectCode))();
    } catch (err) {
        console.error(err);
    }

    return resultObject;
}

function applyNewTranslates(translates, newTranslates) {
    const removedKeys = Object.keys(translates)
        .filter((key) => !(key in newTranslates));

    for (const key of removedKeys) {
        delete translates[ key ];
    }

    Object.assign(translates, newTranslates);
}
